import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

// The POS page moved to /venue/pos when it joined the admin-only venue
// toolset. This keeps the old /pos address working — including Stripe's
// return URLs and saved tablet bookmarks — carrying the query string across
// so a payment confirmation still resolves.
export default function PosRedirect() {
  const { search } = useLocation();
  return <Navigate to={`/venue/pos${search}`} replace />;
}